import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import RGL, { WidthProvider } from 'react-grid-layout';
import _ from 'lodash';
import * as Actions from './../store/actions';
import Widget from '../widgets/Widget';

import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

const styles = theme => ({
});
const ReactGridLayout = WidthProvider(RGL);

class CompanyDashboard extends Component {
    state = {
        layout: [],
    }

    constructor(props) {
        super(props);
    }

    generateGrid() {
        const { dashboard_layout } = this.props;
        return dashboard_layout.map((widget_info) => {
            return (
                <div key={widget_info.auth_dashboard_id}>
                    <Widget widget_name={widget_info.WidgetName} />
                </div>
            )
        });
    }

    onLayoutChange = (layout) => {
        const { auth, saveLayout } = this.props;

        saveLayout(auth.user.data.auth_id, layout);
    }

    render() {
        return (
            <ReactGridLayout
                layout={this.props.grid_layout}
                onLayoutChange={this.onLayoutChange}
                className="layout"
                rowHeight={30}
                cols={12}
            >
                {this.generateGrid()}
            </ReactGridLayout>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        saveLayout: Actions.saveLayout
    }, dispatch);
}

function mapStateToProps({ dashboardApp, auth }) {
    return {
        dashboard_layout:         dashboardApp.dashboard.dashboard_layout,
        grid_layout:              dashboardApp.dashboard.grid_layout,
        auth:                     auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyDashboard)));


// WEBPACK FOOTER //
// src/main/content/dashboard/components/CompanyDashboard.js